import { css } from "../../css/util.compose-css";

export const heading = css`
  margin: 0;
`;

export const paragraph = css`
  margin: 0;
`;
